import i18n from '@/lang';
/* unplugin-vue-components disabled */
import { Button as __unplugin_components_11 } from 'vant/es';
import 'vant/es/button/style/index';
import { Field as __unplugin_components_10 } from 'vant/es';
import 'vant/es/field/style/index';
import { Field as __unplugin_components_9 } from 'vant/es';
import 'vant/es/field/style/index';
import { Field as __unplugin_components_8 } from 'vant/es';
import 'vant/es/field/style/index';
import __unplugin_components_7 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/SmyMapAddress.vue';
import __unplugin_components_6 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Base/SinglePicker.vue';
import { CellGroup as __unplugin_components_5 } from 'vant/es';
import 'vant/es/cell-group/style/index';
import { Form as __unplugin_components_4 } from 'vant/es';
import 'vant/es/form/style/index';
import { Card as __unplugin_components_3 } from 'vant/es';
import 'vant/es/card/style/index';
import { Field as __unplugin_components_2 } from 'vant/es';
import 'vant/es/field/style/index';
import { Field as __unplugin_components_1 } from 'vant/es';
import 'vant/es/field/style/index';
import { CellGroup as __unplugin_components_0 } from 'vant/es';
import 'vant/es/cell-group/style/index';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "determineOrder"
  }, [_c('div', {
    staticClass: "orderBox"
  }, [_c('div', {
    staticClass: "connect"
  }, [_c('div', {
    staticClass: "address",
    on: {
      "click": function ($event) {
        _vm.isAddressListShow = true;
      }
    }
  }, [_c('div', {
    staticClass: "addressLeft"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/MH3.9/dingwei.png"),
      "alt": ""
    }
  }), _vm.address ? _c('div', {
    staticClass: "info"
  }, [_c('p', {
    staticClass: "adres"
  }, [_vm._v(_vm._s(_vm.address.gps_addr))])]) : _c('div', [_vm._v(i18n.tc("298"))])]), _c('img', {
    staticClass: "arrow",
    attrs: {
      "src": require("@/assets/img/MH3.9/right-arrow.png"),
      "alt": ""
    }
  })]), _c(__unplugin_components_0, {
    staticClass: "linkperson",
    attrs: {
      "inset": ""
    }
  }, [_c(__unplugin_components_1, {
    attrs: {
      "label": i18n.tc("156"),
      "placeholder": i18n.tc("299")
    },
    model: {
      value: _vm.from.linkperson,
      callback: function ($$v) {
        _vm.$set(_vm.from, "linkperson", $$v);
      },
      expression: "from.linkperson"
    }
  }), _c(__unplugin_components_2, {
    attrs: {
      "label": i18n.tc("300"),
      "placeholder": i18n.tc("301")
    },
    model: {
      value: _vm.from.linkperson_phone,
      callback: function ($$v) {
        _vm.$set(_vm.from, "linkperson_phone", $$v);
      },
      expression: "from.linkperson_phone"
    }
  })], 1)], 1), _c('div', {
    staticClass: "product"
  }, _vm._l(_vm.settlementProduct, function (item) {
    return _c('div', {
      key: item.fk_t_order_cart_id,
      staticClass: "contentBox"
    }, [_c(__unplugin_components_3, {
      attrs: {
        "num": item.add_munber,
        "price": item.price,
        "title": item.goods_name,
        "thumb": item.goods_image
      },
      scopedSlots: _vm._u([{
        key: "footer",
        fn: function () {
          return [_c('div', {
            staticClass: "way"
          }, [_c('span', [_vm._v(i18n.tc("260"))]), _c('span', [_vm._v(i18n.tc("261"))])]), _c('div', {
            staticClass: "freight"
          }, [_c('span', [_vm._v(i18n.tc("262"))]), _c('span', [_vm._v(i18n.tc("263"))])]), _c('span', [_vm._v(i18n.tc("302") + _vm._s((item.add_munber * item.price).toFixed(2)))])];
        },
        proxy: true
      }], null, true)
    })], 1);
  }), 0), _c('div', {
    staticClass: "paymentInformation"
  }, [_c(__unplugin_components_4, [_c(__unplugin_components_5, {
    attrs: {
      "inset": ""
    }
  }, [_c(__unplugin_components_6, {
    attrs: {
      "title": i18n.tc("256"),
      "data": _vm.columns,
      "format": function (v) {
        return {
          name: v.text,
          value: String(v.value)
        };
      }
    },
    model: {
      value: _vm.from.pay_method,
      callback: function ($$v) {
        _vm.$set(_vm.from, "pay_method", $$v);
      },
      expression: "from.pay_method"
    }
  }), _c('group', [_c(__unplugin_components_7, {
    on: {
      "on-change": _vm.selectAddress
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: 120 + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(i18n.tc("303"))])])], 1), _c(__unplugin_components_8, {
    attrs: {
      "name": i18n.tc("264"),
      "label": i18n.tc("264"),
      "placeholder": i18n.tc("304")
    },
    model: {
      value: _vm.from.invoice_title,
      callback: function ($$v) {
        _vm.$set(_vm.from, "invoice_title", $$v);
      },
      expression: "from.invoice_title"
    }
  }), _c(__unplugin_components_9, {
    attrs: {
      "type": i18n.tc("244"),
      "name": i18n.tc("244"),
      "label": i18n.tc("244"),
      "placeholder": i18n.tc("244")
    },
    model: {
      value: _vm.from.detail_address,
      callback: function ($$v) {
        _vm.$set(_vm.from, "detail_address", $$v);
      },
      expression: "from.detail_address"
    }
  }), _c(__unplugin_components_10, {
    attrs: {
      "type": i18n.tc("266"),
      "name": i18n.tc("266"),
      "label": i18n.tc("266"),
      "placeholder": i18n.tc("266")
    },
    model: {
      value: _vm.from.create_remark,
      callback: function ($$v) {
        _vm.$set(_vm.from, "create_remark", $$v);
      },
      expression: "from.create_remark"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v(i18n.tc("281") + _vm._s(_vm.sumPrice))]), _c(__unplugin_components_11, {
    staticClass: "btn",
    attrs: {
      "size": "small",
      "round": "",
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(i18n.tc("305"))])], 1)]), _c('AddressList', {
    on: {
      "on-ok": _vm.AddressClick
    },
    model: {
      value: _vm.isAddressListShow,
      callback: function ($$v) {
        _vm.isAddressListShow = $$v;
      },
      expression: "isAddressListShow"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };